import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { GuideData, GuidePreview, PlainDoc, Voice } from "../../core/types/guide"
import {Guide, VideoClip} from '../../core/types/guide';
import { RootState } from '../store';
import { GigaUserApi } from "@giga-user-fern/api";
import logger from "../../utils/logger";

export type PlatformHomePage = "home" | "bin" | "organization" | "anal"

type PlatformUiState = {
    value: {
        homePage: PlatformHomePage
    }
}


const initialState: PlatformUiState = {
    value: {
        homePage: "home"
    }
}

export const platformUiSlice = createSlice({
    name: 'guide', 
    initialState,
    reducers: {

        setHomePage: (state, action: PayloadAction<PlatformHomePage>) => {
            state.value.homePage = action.payload
        }
        
    }
})

export const {setHomePage} = platformUiSlice.actions

// Other code such as selectors can use the imported `RootState` type
export default platformUiSlice.reducer


